// extracted by mini-css-extract-plugin
export default {"values":"Values_values__0WWaZ","values_conent":"Values_values_conent__54Kzu","col":"Values_col__qNp5B","containerContent":"Values_containerContent__RO46l"};